import { QrAffiliateContext } from "./_context";

export const QrAffiliateProvider = QrAffiliateContext.Provider